module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-white",
    staticStyle: {
      "box-shadow": "2px 2px 5px #ccc"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    staticStyle: {
      "justify-content": "right",
      "position": "relative",
      "top": "15px"
    },
    attrs: {
      "id": "navbarCollapse"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "20px",
      "top": "-30px",
      "font-size": "14px",
      "color": "#666"
    }
  }, [_c('i', {
    staticClass: "bi bi-envelope-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v(" cliff@adachemicals.com\n          \n            "), _c('img', {
    staticStyle: {
      "width": "25px",
      "height": "18px",
      "cursor": "pointer",
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/images/en.jpeg"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('en')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "25px",
      "height": "18px",
      "cursor": "pointer",
      "margin-left": "3px"
    },
    attrs: {
      "src": "/static/images/zh.jpeg"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('zh')
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav ms-auto"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarLandings"
    },
    on: {
      "click": function($event) {
        return _vm.jump('/')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_home')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "aboutUsMenu",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_about')) + " "), _c('i', {
    staticClass: "bi bi-chevron-down",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "aboutUsMenu"
    }
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('aboutus')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_company')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('team')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_team')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('customer')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_customer')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('partner')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_partner')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "productMenu",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_product')) + " "), _c('i', {
    staticClass: "bi bi-chevron-down",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "productMenu"
    }
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_1')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_2')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_3')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('4')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_4')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarAccount"
    },
    on: {
      "click": function($event) {
        return _vm.jump('service')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_service')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarAccount"
    },
    on: {
      "click": function($event) {
        return _vm.jump('contactus')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_contact')) + "\n              ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "navbar-brand-img",
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "..."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "id": "menuButton",
      "type": "button",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#navbarCollapse",
      "aria-controls": "navbarCollapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1065548"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar.vue
// module id = 428
// module chunks = 1